/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import StatusContainer from "../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount";
import { setHideBreadCrumb } from "../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { disableSwitcher } from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import { fetchTdsTransactionDetails } from "../../../../redux/features/transactions/taxTransaction/taxTransactionDetails";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import useCategories from "../../../../utils/useCategories";

const TaxationTransactionSuccess = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const categoryMapper = useCategories();

  const taxTransaction = useSelector((state) => state.tdsTransactionDetails);
  const { tdsTransactionDetailsLoading, tdsTransactionDetailsError } =
    useSelector((state) => state.tdsTransactionDetails);

  const status =
    taxTransaction?.tdsTransactionDetailsData?.transaction[0]?.lifecycle_status;

  const viewDetailsHandler = () => {
    navigate(
      `/tax_transaction_dashboard/tax_transaction_view_all/tax_transaction_detail_page/${id}`,
    );
  };

  const taxAccount = () => {
    const taxAccountId =
      taxTransaction?.tdsTransactionDetailsData?.transaction[0].tds_account_id;

    navigate(
      `/tax_account_dashboard/tax_account_view_all/tax_account_detail_page/${taxAccountId}`,
    );
  };

  const sourceAccount = () => {
    const sourceId =
      taxTransaction?.tdsTransactionDetailsData?.transaction[0]
        .owner_account_id;
    navigate(
      `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${sourceId}`,
    );
  };

  const createAccountHandler = () => {
    navigate("/tax_transaction_dashboard/create_tax_transaction");
    try {
      sessionStorage.removeItem("recreate_ben");
    } catch {}
  };

  const dashboardHandler = () => {
    navigate("/tax_transaction_dashboard");
  };

  const formatCategory = (text) =>
    text ? text.replaceAll("_", " ").toUpperCase() : "";

  const buttonRows = [
    [
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.ADD_BUTTON,
        handleFunction: createAccountHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: ICONS?.VIEW_DETAILS,
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: ICONS?.DASHBOARD,
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "dark",
      },
    ],
  ];

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);

  useEffect(() => {
    if (tdsTransactionDetailsError === "Request failed with status code 404") {
      navigate(`/tax_transaction_dashboard/create_tax_transaction/failed`);
    }
  }, [tdsTransactionDetailsError]);

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(fetchTdsTransactionDetails(id));
    }
  }, [id, dispatch]);

  return (
    <>
      <StatusContainer
        isLoading={tdsTransactionDetailsLoading}
        status="success"
        hoverOption="white"
        title={
          status === "approved"
            ? "Tax transaction has been created and approved"
            : status === "queued"
              ? "Tax transaction has been approved"
              : status === "settled"
                ? "Tax transaction settled successfully."
                : status === "pending"
                  ? "Tax transaction created successfully and approval is pending."
                  : ""
        }
        subtitle={
          status === "approved" || status === "queued"
            ? "It will be auto settled once sufficient balance is available in the source account."
            : ""
        }
        buttonRows={buttonRows}
      >
        <TabsWeapperSection title="Transaction details">
          <>
            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: accountNameStandardised(
                    taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                      ?.tds_account_name,
                  ),
                  leftSubTitle: "Account name",
                  hasRight: true,
                  rightText: true,
                  rightTitleTextColor: "var(--text-primary)",
                  rightTitle: (
                    <>
                      INR{" "}
                      <FormatAmount
                        price={
                          taxTransaction?.tdsTransactionDetailsData
                            ?.transaction[0]?.amount ??
                          GlobalConfiguration?.lengthCheckZero
                        }
                      />
                    </>
                  ),
                  rightTextFontWeight: "semibold",
                  rightSubTitle: "Amount",
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={taxAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                      ?.tds_account_bank_acc_no,
                  ),
                  leftSubTitle: "Destination account number",
                  ifsc: taxTransaction?.tdsTransactionDetailsData
                    ?.transaction[0]?.tds_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle: formatCategory(
                    taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                      ?.category,
                  ),
                  leftSubTitle: "Tax types",
                  icon: categoryMapper(
                    taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                      ?.category,
                  ),
                },
              ]}
            />

            {taxTransaction?.tdsTransactionDetailsData?.transaction[0]
              .category &&
              taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                ?.tax_section && (
                <InfoCard
                  bgColor="var(--positive-card)"
                  rows={[
                    {
                      leftTitle:
                        taxTransaction?.tdsTransactionDetailsData
                          ?.transaction[0].tax_section?.section_name,
                      leftSubTitle: "Tax section",
                      rightText: true,
                      rightTitleTextColor: "var(--text-primary)",
                      rightTitle:
                        taxTransaction?.tdsTransactionDetailsData
                          ?.transaction[0]?.tax_section?.description,
                      rightSubTitle: "Section description",
                    },
                  ]}
                />
              )}

            <InfoCard
              bgColor="var(--positive-card)"
              onClick={sourceAccount}
              hoverable="black"
              rows={[
                {
                  leftTitle: formatAccountNumber(
                    taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                      ?.owner_account_bank_acc_no,
                  ),
                  leftSubTitle: globalText?.SOURCE_ACCOUNT_NUMBER,
                  ifsc: taxTransaction?.tdsTransactionDetailsData
                    ?.transaction[0]?.owner_account_ifsc_code,
                  rightIcon: true,
                },
              ]}
            />

            {taxTransaction?.tdsTransactionDetailsData?.transaction[0]
              ?.confidential_transaction === "Y" && (
              <InfoCard
                bgColor="var(--positive-card)"
                rows={[
                  {
                    leftTitle: globalText?.YES,
                    leftSubTitle: globalText?.CONFIDENTIAL_TRANSACTION,
                    icon: ICONS?.CONFIDENTIAL_TRANSACTION_BLUE_BG,
                  },
                ]}
              />
            )}

            <InfoCard
              bgColor="var(--positive-card)"
              rows={[
                {
                  leftTitle:
                    Array.isArray(
                      taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                        .labels,
                    ) &&
                    taxTransaction?.tdsTransactionDetailsData?.transaction[0]
                      .labels.length > 0
                      ? taxTransaction?.tdsTransactionDetailsData?.transaction[0].labels.map(
                          (item, index, arr) => (
                            <span key={index}>
                              {item}
                              {index <
                                arr.length -
                                  GlobalConfiguration?.lengthCheckOne && ", "}
                            </span>
                          ),
                        )
                      : globalText?.NO_LABELS_ASSIGNED,
                  leftSubTitle: "Labels",
                },
              ]}
            />
          </>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default TaxationTransactionSuccess;
